<template>
    <div class="main main-padding">
        <Row :gutter="10" style="margin-top: 20px;">
            <!-- 智能PC总用户数 -->
            <Col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                <Card style="height:413px;">
                    <div style="text-align:center; font-weight: bold;">
                        <img src="../../../assets/images/computer.png" style="margin-top: 14%;">
                        <div style="margin-top: -2%;font-size:37px">智能PC总用户数:{{baseData.intellUserNum}}</div>
                    </div>
                </Card>
            </Col>
            <!--  使用智能PC次数Top10用户 -->
            <Col :xs="12" :sm="12" :md="18" :lg="18" :xl="18">
                <histogram-charts
                    :chartsTitle="'使用智能PC次数Top10用户'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'pc_user_top'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="pcUserTop"
                ></histogram-charts>
            </Col>
        </Row>
        <!--  场景使用分布、智能PC最近一月活跃人数、智能PC每周使用人数 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <pie-charts
                    :chartsTitle="'场景使用分布'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'pc_scene_distri'"
                    :pieChartsName="'场景分布'"
                    ref="pcSceneDistri"
                ></pie-charts>
            </Col>
            <Col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <line-charts
                    :chartsTitle="'智能PC最近一月活跃人数'"
                    :chartsId="'pc_month_user'"
                    :lineCompany="'人'"
                    ref="pcMonthUser"
                ></line-charts>
            </Col>
            <Col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <line-charts
                    :chartsTitle="'智能PC每周使用人数'"
                    :chartsId="'pc_week_user'"
                    :lineCompany="'人'"
                    ref="pcWeekUser"
                ></line-charts>
            </Col>
        </Row>
        <!--  各校使用智能PC用户数 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'各校使用智能PC用户数'"
                    :isShowMore=false
                    :isClickCharts=false
                    :isSchool=true
                    :chartsId="'pc_use_number'"
                    :height="'360px'"
                    :histogramTooltip="'people'"
                    ref="pcUseNumber"
                ></histogram-charts>
            </Col>
        </Row>
        <!--  各学科智能PC使用次数 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'各学科智能PC使用次数'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'pc_subject_user'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="pcSubjectUser"
                ></histogram-charts>
            </Col>
        </Row>
    </div>
</template>
<script>
    import HistogramCharts from "../../../components/charts/HistogramCharts.vue";//柱状图
    import PieCharts from "../../../components/charts/PieCharts.vue";//饼状图
    import LineCharts from "../../../components/charts/LineCharts.vue";//折线图
    import {findPCUseNum,findPCUseTop,findScenesPcMap,findPCWeeklyUseNum,findPCUseWeekly,findPCUseSchool,findPCSubjectAnaly} from "../../../service/api.js";

    export default {
        name: "intell-user-num",
        data () {
            return {
                baseData: {
                    intellUserNum: 0  //智能PC总用户数
                }
            };
        },
        components: {
            HistogramCharts,//柱状图组件
            PieCharts,//饼图组件
            LineCharts//折线图
        },
        methods: {
            /**
             * 获取智能PC总用户数
             */
            async getPCUseNum () {
                let _this = this;
                await findPCUseNum()
                    .then(function (data) {
                        _this.baseData.intellUserNum = data;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取PC种子用户Top10
             */
            async getIntellPCUseTop () {
                let _this = this;
                await findPCUseTop()
                    .then(function (data) {
                        let userList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < userList.length; i++) {
                            xDataArr.push(userList[i].fullName);
                            seriesDataArr.push(userList[i].count);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.pcUserTop.initDataSource(userList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取PC的使用场景分布
             */
            async getScenesPcMap () {
                let _this = this;
                await findScenesPcMap()
                    .then(function (data) {
                        let sceneList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < sceneList.length; i++) {
                            let obj = {};
                            //处理数据用于渲染图表
                            obj.value = sceneList[i].userCount;
                            obj.name = sceneList[i].clsName;
                            dataArr.push(obj);
                            nameArr.push(sceneList[i].clsName);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.pcSceneDistri.initDataSource(sceneList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取智能PC最近一月活跃人数
             */
            async getPCWeeklyUseNum () {
                let _this = this;
                await findPCWeeklyUseNum()
                    .then(function (data) {
                        let numList = data;
                        let dataArr = [];
                        let numArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < numList.length; i++) {
                            dataArr.push(numList[i].day);
                            numArr.push(numList[i].number);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.pcMonthUser.initDataSource(numList, dataArr, numArr);
                        })

                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取智能PC每周使用人数
             */
            async getIntellPCUseWeekly () {
                let _this = this;
                await findPCUseWeekly()
                    .then(function (data) {
                        let numList = data;
                        let weekArr = [];
                        let countArr = [];
                        for (let i = 0; i < numList.length; i++) {
                            let strWeekStr = numList[i].dates.substring(5, 11);
                            let endWeekStr = numList[i].dates.substring(16);
                            let weekStr = strWeekStr + endWeekStr;
                            weekArr.push(weekStr);
                            countArr.push(numList[i].number);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.pcWeekUser.initDataSource(numList, weekArr, countArr);
                        })

                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取使用智能PC学校分布
             */
            async getPCUseSchool () {
                let _this = this;
                await findPCUseSchool()
                    .then(function (data) {
                        let schoolList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < schoolList.length; i++) {
                            xDataArr.push(schoolList[i].schoolName);
                            seriesDataArr.push(schoolList[i].count);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.pcUseNumber.initDataSource(schoolList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取智能PC用户学科分布
             */
            async getIntPCSubjectAnaly () {
                let _this = this;
                await findPCSubjectAnaly()
                    .then(function (data) {
                        let subjectList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        let displayName = "";
                        //处理数据以渲染图表
                        for (let i = 0; i < subjectList.length; i++) {
                            displayName = subjectList[i].subName;
                            xDataArr.push(
                                displayName.length > 5
                                    ? displayName.substring(0, 5) + "..."
                                    : displayName
                            );
                            seriesDataArr.push(subjectList[i].userCount);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.pcSubjectUser.initDataSource(subjectList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            }
        },
        mounted () {
            this.$store.commit("SET_TOPHEADERNAME", "智能PC产品使用统计");
            //获取智能PC总用户数
            this.getPCUseNum();
            //获取PC种子用户Top10
            this.getIntellPCUseTop();
            //获取PC的使用场景分布
            this.getScenesPcMap();
            //获取智能PC最近一月活跃人数
            this.getPCWeeklyUseNum();
            //获取智能PC每周使用人数
            this.getIntellPCUseWeekly();
            //获取使用智能PC学校分布
            this.getPCUseSchool();
            //获取智能PC用户学科分布
            this.getIntPCSubjectAnaly();

        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../style/home";
</style>
